import * as React from 'react';
import { shouldPopupShown } from './utils/should_popup_shown';
import { DEMAND_POPUP_TICK, DEMAND_POPUP_TIME } from './constants/demand_popup_time';
import { isInBrowser } from '../../../app/helpers/browser_helper';
import { RequestDemandButton } from '../../containers/realtor_demand/request_demand_button';
import { DemandBannerLocation } from '../../containers/realtor_demand/contants/demand_banner_location';

import s from './demand_activity_popup.css';

export interface IDemandActivityPopupProps {
  /** Текущий url страницы **/
  pathname: string;
  isDesktop?: boolean;
}

/**
 * Компонент, отображающий попап банера заявки риелтора при активности пользователя
 * на страницах форума риелторов в течении 6 минут
 */
export const DemandActivityPopup: React.FC<IDemandActivityPopupProps> = React.memo(({ pathname }) => {
  const [showPopup, setShowPopup] = React.useState(false);
  const [dialogOpen] = React.useState(false);
  const hasShownRef = React.useRef(false);
  const trackCheckTimeoutIdRef = React.useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const stopTrack = React.useCallback(() => {
    if (trackCheckTimeoutIdRef.current !== undefined) {
      clearTimeout(trackCheckTimeoutIdRef.current);
      trackCheckTimeoutIdRef.current = undefined;
    }
  }, []);

  const startTrack = React.useCallback(() => {
    if (trackCheckTimeoutIdRef.current !== undefined || !isInBrowser() || hasShownRef.current) {
      return;
    }

    const trackTimeStart = Date.now();

    const trackCheckTick = () => {
      const currentTime = Date.now();
      if (currentTime - trackTimeStart >= DEMAND_POPUP_TIME) {
        hasShownRef.current = true;
        setShowPopup(true);
        stopTrack();
      } else {
        trackCheckTimeoutIdRef.current = setTimeout(trackCheckTick, DEMAND_POPUP_TICK);
      }
    };

    trackCheckTimeoutIdRef.current = setTimeout(trackCheckTick, DEMAND_POPUP_TICK);
  }, [stopTrack]);

  React.useEffect(() => {
    if (shouldPopupShown(pathname)) {
      startTrack();
    }

    return stopTrack;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (shouldPopupShown(pathname)) {
      startTrack();
    } else {
      stopTrack();
    }
  }, [pathname, startTrack, stopTrack]);

  if (!showPopup) {
    return null;
  }

  return (
    <div className={`${s['popup']} ${dialogOpen ? s['popup__dialog-open'] : ''}`}>
      <div className={`${s['description']} ${s['desktop']}`}>
        <div className={s['description__title']}>Нужна помощь риелтора?</div>
        <div>
          Подберем специалиста, который возьмет на себя решение юридических вопросов
        </div>
      </div>
      <div className={`${s['description']} ${s['mobile']}`}>
        Нужен риелтор? Бесплатно подберем специалиста
      </div>
      <div className={s['divider']} />
      <div className={s['action']}>
        <RequestDemandButton
          bannerLocation={DemandBannerLocation.POPUP}
          onCloseDialog={() => setShowPopup(false)}
          renderButton={({ onClick }) => (
            <div className={s['button']} onClick={onClick}>Подробнее</div>
          )}
        />
      </div>
    </div>
  );
}, (prevProps, nextProps) => prevProps.pathname === nextProps.pathname);
